import { render } from "./AttachmentPreview.vue?vue&type=template&id=7f9746f2&scoped=true"
import script from "./AttachmentPreview.vue?vue&type=script&lang=js"
export * from "./AttachmentPreview.vue?vue&type=script&lang=js"

import "./AttachmentPreview.vue?vue&type=style&index=0&id=7f9746f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f9746f2"]])

export default __exports__